module.exports = __webpack_public_path__ + "static/media/ahlens.41fb5406.svg";